
import React from 'react';
import Chart from 'react-apexcharts';

interface GraficoAreaProps {
  height?: number;
  series: {
    name: string;
    data: number[];
  }[];
  options?: {
    title?: {
      text?: string;
    };
    colors?: string[];
    dataLabels?: {
      enabled?: boolean;
    };
    theme?: {
      mode?: 'dark' | 'light' | undefined;
    };
    xaxis?: { 
      categories?: string[];
    } 
  };
}

const GraficoLinha: React.FC<GraficoAreaProps> = ({ series, options = {}, height }) => {
  return (
    <React.Fragment>
      <Chart
        type='line'
        height={height || 250}
        series={series}
        options={{
          chart: {
            toolbar: {
              show: false 
            }
          },
          legend: { 
            position: 'top',
            show: false,
          },
          title: {
            text: options.title?.text,
          },
          colors: options.colors,
          
          dataLabels: { enabled: options.dataLabels?.enabled },
          theme: {
            mode: options.theme?.mode,
          },
          xaxis: { 
            categories: options.xaxis?.categories
          }         
        }}
      />
    </React.Fragment>
  );
};

export default GraficoLinha;
